import { useLocation } from "react-router-dom";

export const ALLOWED_NON_PREFIXED_PATHS = ["/callbacksV2/shopify"];

export default function useAllowedNonprefixedPage(): boolean {
  const { pathname } = useLocation();
  return ALLOWED_NON_PREFIXED_PATHS.includes(pathname);
}
